import { render, staticRenderFns } from "./ApplicationInstrumentation.vue?vue&type=template&id=b9f27c74&scoped=true"
import script from "./ApplicationInstrumentation.vue?vue&type=script&lang=js"
export * from "./ApplicationInstrumentation.vue?vue&type=script&lang=js"
import style0 from "./ApplicationInstrumentation.vue?vue&type=style&index=0&id=b9f27c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f27c74",
  null
  
)

export default component.exports